import React from 'react';
import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { getIssueTypeStyle } from './streakAuditUtils';

function StreakIssuesList({ issues }) {
  if (!issues?.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
        No issues detected in this range.
      </Typography>
    );
  }

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: '#fafafa' }}>
            <TableCell sx={{ fontWeight: 700 }}>Date</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {issues.map((issue, idx) => {
            const style = getIssueTypeStyle(issue.issueType);
            return (
              <TableRow key={`${issue.localDate}-${issue.issueType}-${idx}`} hover>
                <TableCell>{issue.localDate}</TableCell>
                <TableCell>
                  <Chip
                    label={issue.issueType}
                    size="small"
                    sx={{ bgcolor: style.bg, color: style.color, fontWeight: 600, fontSize: '0.7rem' }}
                  />
                </TableCell>
                <TableCell>{issue.description}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default StreakIssuesList;
